import { ButtonVariant } from '@/components/ButtonVariant';
import { LogoVariant } from '@/components/LogoVariant';
import API from '@/config/api';
import { ID_SUPERCHANCE } from '@/config/game/ids';
import { GameConfig } from '@/config/game/index';

export const siegerchance: GameConfig = {
  id: ID_SUPERCHANCE,
  additionalGameId: 20,
  shortname: 'siegerchance',
  title: 'Siegerchance',
  logo: LogoVariant.Siegerchance,
  button: ButtonVariant.Primary,
  buttonSecondary: ButtonVariant.Secondary,
  jackpotSrc: API.stats.spiel77Shortinfo,
  jackpotLabelPrefix: 'Jackpot',
  jackpotDesc: '1.000.000&nbsp;€&nbsp;<br />Höchstgewinn',
  jackpotTimes: '',
  chanceDesc: 'Chance 1:3.333.333 Mio.',
  steps: [],
  urls: {
    overview: undefined,
    stats: '',
    game: '',
  },
  label: {
    text: 'Siegerchance',
    imgPath: 'logo-sieger-chance.svg',
  },
};
